export default function AppSection() {
  return (
    <section id="app" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            移动入口
          </h2>
          <div className="max-w-lg mx-auto">
            <a
              href="#app"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-5 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className="ri-smartphone-line text-2xl text-primary-600"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">探花系列移动客户端</h3>
                <p className="text-sm text-foreground-500">适配 iOS / Android，随时随地访问探花在线资源，支持离线缓存与收藏功能，流畅体验精品探花精选合集。</p>
              </div>
              <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-xl text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}